module.exports = __webpack_public_path__ + "static/img/bystage_08.632aa0c3.svg";